/**
 * While Remote Console is open, refresh Fleet confirmed settings via GET.
 * Never commands Player. Never overwrites unsaved operator edits.
 */

export const REMOTE_SETTINGS_LIVE_REFRESH_MS = 4000;

export type LiveRefreshMsInput = {
  commandsEnabled: boolean;
  hydrated: boolean;
  fieldIsTouched: boolean;
  isMutating: boolean;
};

export function decideLiveRefreshMs(input: LiveRefreshMsInput): number {
  if (!input.commandsEnabled) return 0;
  if (!input.hydrated) return 0;
  if (input.isMutating) return 0;
  if (input.fieldIsTouched) return 0;
  return REMOTE_SETTINGS_LIVE_REFRESH_MS;
}

export type LiveGetApplyInput = {
  hydrated: boolean;
  fieldIsTouched: boolean;
  isMutating: boolean;
  snapshotComplete: boolean;
  incomingSyncedAt: string | null | undefined;
  lastAppliedSyncedAt: string | null | undefined;
  applyGeneration: number;
  currentGeneration: number;
};

export function shouldApplyLiveGet(input: LiveGetApplyInput): boolean {
  if (!input.hydrated) return false;
  if (input.fieldIsTouched) return false;
  if (input.isMutating) return false;
  if (!input.snapshotComplete) return false;
  if (input.applyGeneration !== input.currentGeneration) return false;
  if (!input.incomingSyncedAt) return false;
  if (input.incomingSyncedAt === input.lastAppliedSyncedAt) return false;
  if (
    input.lastAppliedSyncedAt &&
    input.incomingSyncedAt < input.lastAppliedSyncedAt
  ) {
    return false;
  }
  return true;
}
